import { Buffer } from 'buffer'

export const decodeJwtToken = (token: string) => {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace('-', '+').replace('_', '/')
  const decodedJwt = Buffer.from(base64, 'base64')
  return JSON.parse(decodedJwt.toString())
}
